export const pendingAppoHeaders = ["Image", "Full Name", "Appointment Date", "Booking Date", "Status", "Action"]

export const statusVarients = {
  pending: { label: "Pending", bg: "#fff3e0", color: "#e65100" },
  accepted: { label: "Accepted", bg: "#e8f5e8", color: "#2e7d32" },
  scheduled: { label: "Scheduled", bg: "#e3f2fd", color: "#1565c0" },
  completed: { label: "Completed", bg: "#e8f5e9", color: "#2e7d32" },
  rejected: { label: "Rejected", bg: "#ffebee", color: "#c62828" },
  cancelled: { label: "Cancelled", bg: "#f5f5f5", color: "#616161" },
  late_cancelled: { label: "Late Cancelled", bg: "#ffebee", color: "#c62828" },
  no_refund_cancelled: { label: "Cancelled", bg: "#ffebee", color: "#c62828" },
  expired: { label: "Expired", bg: "#ffebee", color: "#c62828" },
  no_show_specialist: { label: "No Show", bg: "#fff3e0", color: "#f57c00" },
  no_show_member: { label: "No Show", bg: "#fff3e0", color: "#f57c00" },
  "no-show": { label: "No Show", bg: "#fff3e0", color: "#f57c00" },
}

export const chipVariants = {
  rejected: "red",
  accepted: "green",
  cancelled: "gray",
  late_cancelled: "red",
  no_refund_cancelled: "red",
  expired: "red",
  pending: "orange",
  scheduled: "blue",
  completed: "green",
  no_show_specialist: "yellow",
  no_show_member: "yellow",
  "no-show": "yellow",
}